export class BaseSingleton {
  protected constructor() {
    // @no-action
  }
}
